import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
const FEATURED_REVIEW_NAMES = ['Isha Shah', 'David Bushman', 'Marquita Harris'];
export function Page31Reviews() {
  const reviews = STORM_REVIEWS.filter(r => FEATURED_REVIEW_NAMES.includes(r.name));
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2832">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2833">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2834">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-2835">
            Real Families. Real Reviews.
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-2836">
            These are real Storm students and parents. No stock testimonials.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-2837">
          {reviews.map(r => <ReviewCard key={r.name} quote={r.quote} name={r.name} label={r.label} data-id="element-2838" />)}
        </div>
      </div>
    </section>;
}